import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';
import { CaptainDAO } from '../../../../core/services/dao/captainDAO';
import { map, take } from 'rxjs/operators';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { environment } from '../../../../environments/environment';

@Injectable()
export class CaptainsResolve implements Resolve<any> {
  constructor(
    private authService: AuthService,
    private captainDAO: CaptainDAO,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  resolve(route: ActivatedRouteSnapshot) {
    const captainResolve = this.captainDAO.loadCaptainsForAdminGrid();
    const sessionResolve = this.authService.checkSession();
    return combineLatest([captainResolve, sessionResolve]).pipe(
      map(([captainResolve, sessionResolve]) => ({
        captainResolve,
        sessionResolve,
      })),
      take(1),
    );
  }
}
